import { useQuery } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { fetchCollectionCount } from './utils';

export const useGetColectionCount = (collectionPath: string) => useQuery<number, FirebaseError>({
  queryKey: [collectionPath],
  queryFn: () => fetchCollectionCount(collectionPath),
  retry: 0,
});
